import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface AccountLockoutDialogData {
	message: string;
	forgotPasswordUrl: string;
	dialogTitleId?: string;
}

@Component({
	selector: 'account-lockout-dialog',
	templateUrl: './account-lockout-dialog.component.html',
	styleUrls: ['./account-lockout-dialog.component.scss'],
	standalone: false
})
export class AccountLockoutDialogComponent {
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<AccountLockoutDialogData>
	): MatDialogRef<AccountLockoutDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? AccountLockoutDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, AccountLockoutDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `account-lockout-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	constructor (
		private dialogRef: MatDialogRef<AccountLockoutDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AccountLockoutDialogData
	) {
		this.data.dialogTitleId ??= AccountLockoutDialogComponent.getDialogTitleId();
	}

	public close () {
		this.dialogRef.close();
	}
}
